
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiFileUploadGoogle as ObiFileUploadGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-file-upload-google.js';
 
 
 

 
 export const ObiFileUploadGoogle = createComponent({
   react: React,
   tagName: 'obi-file-upload-google',
   elementClass: ObiFileUploadGoogleElement,
   events: {
     
   }
  });
 
 